<template>

    <el-button v-if="isInProofreading"
               link
               type="primary"
               size="small"
               @click.prevent="openProofreadingDoc"
               v-on:click.middle="openProofreadingDocInNewTab">
        {{ $t('fileActions.view') }}
    </el-button>

    <el-button v-else
               link
               type="primary"
               size="small"
               :disabled="isEditingBlocked"
               @click.prevent="openDoc"
               v-on:click.middle="openDocInNewTab">
        {{ $t('fileActions.edit') }}
    </el-button>

</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { DocumentRow } from '@/models/DocumentRow'
    import { DocumentStatus } from '@/models/DocumentStatus'

    import { navigationService } from '@/services/navigationService'

    export default defineComponent({
        props: {
            rowData: Object as PropType<DocumentRow>,
        },
        computed: {
            documentRow(): DocumentRow {
                return this.rowData as DocumentRow;
            },
            isInProofreading(): boolean {
                return this.documentRow?.status === DocumentStatus.InProofreading;
            },
            isEditingBlocked(): boolean {
                return this.documentRow &&
                    this.documentRow.status !== DocumentStatus.Active &&
                    this.documentRow.status !== DocumentStatus.ProofreadingComplete;
            },
        },
        methods: {
            openDoc() {
                navigationService.goDocumentPage(this.documentRow.id);
            },
            openDocInNewTab() {
                const url = navigationService.getDocumentUrl(this.documentRow.id);
                window.open(url, '_blank', 'noreferrer');
            },
            openProofreadingDoc() {
                navigationService.goProofreadingDocumentPage(this.documentRow.id);
            },
            openProofreadingDocInNewTab() {
                const url = navigationService.getProofreadingDocumentUrl(this.documentRow.id);
                window.open(url, '_blank', 'noreferrer');
            },
        },
    })

</script>
